import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from 'store/modules/bottlesFilter'
import { actionCreators as staticFiltersActions } from 'store/modules/staticFilters'
import { localized, withDialogs } from 'decorators'
import { FiltersForm } from './form'
import { useStyles } from './index.css'

const Filters = (props) => {
  const classes = useStyles()
  return (
    <FiltersForm {...props} classes={classes} />
  )
}

export default connect(
  ({ bottlesFilter, staticFilters }) => ({ bottlesFilter, staticFilters }),
  {
    addColumn: actionCreators.addColumn,
    removeColumn: actionCreators.removeColumn,
    updateColumn: actionCreators.updateColumn,
    applyFilter: actionCreators.applyFilter,
    clearFilters: actionCreators.clearFilters,
    load: actionCreators.load,
    update: actionCreators.update,
    save: staticFiltersActions.save,
    get: staticFiltersActions.get,
    deleteFilter: staticFiltersActions.delete
  })(withDialogs(localized(Filters)))
